import { visit, ActionType } from "./types";

const setVisit = (data: visit) => {
  return {
    type: ActionType.SET_VISIT,
    payload: data,
  };
};

export default setVisit;
